import { memo } from "react";
import { ReactComponent as laborLogo } from "./laborLogo.svg";
import { ReactComponent as laborLogoNavBar } from "./laborLogoletras.svg";
import { ReactComponent as laborLogo2 } from "./LaborFooter.svg";

export const LaborLogoMemo = memo(laborLogo);
export const LaborLogoMemo2 = memo(laborLogo2);
export const LaborLogoNavBar = memo(laborLogoNavBar);
